function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Row, Column } from '@signicat/designi/components/layout';
import { Empty } from '@signicat/designi/components/containers';
import { Button } from '@signicat/designi/components/buttons';
import { media } from '@signicat/designi/helpers/responsive';
import { Autocomplete, Toggle } from '@signicat/designi/components/inputs';
import { Feature } from '@signiapp/core/components';
import coreStore from '@signiapp/core/store';
import { orders as ordersActions } from "../../store/actions";
import { contacts as contactService } from "../../services";
import { t } from "../../helpers/i18n";
import { defaultRecipientLanguageSelector } from "../../store/selectors/orders";
import Signer from "./signers/Signer";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { debounce } from 'lodash';
var SequentialToggle = styled('span').withConfig({
  displayName: "Signers__SequentialToggle",
  componentId: "sc-vqf31t-0"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var HiddenFeature = styled(Feature).withConfig({
  displayName: "Signers__HiddenFeature",
  componentId: "sc-vqf31t-1"
})(["display:none;"]);
var Signers = /*#__PURE__*/forwardRef(function (props, ref) {
  var dispatch = useDispatch();
  var defaultLanguage = useSelector(defaultRecipientLanguageSelector('create'));
  var _useSelector = useSelector(function (state) {
      return state.module.settings;
    }),
    signature = _useSelector.signature;
  var recipients = useSelector(function (state) {
    return state.create.data.signers;
  });
  var orderData = useSelector(function (state) {
    return state.create.data;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    contactSignersSetup = _useState2[0],
    setContactSignersSetup = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    arrangedRecipients = _useState4[0],
    setArrangedRecipients = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    arrangedByUser = _useState6[0],
    setArrangedByUser = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSMSNotificationFeatureEnabled = _useState8[0],
    setSMSNotificationFeatureEnabled = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    contactsOptions = _useState10[0],
    setContactsOptions = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedContacts = _useState12[0],
    setSelectedContacts = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    foundLists = _useState14[0],
    setFoundLists = _useState14[1];
  var smsNotificationFeatureToggle = function smsNotificationFeatureToggle(e) {
    return setSMSNotificationFeatureEnabled(e);
  };
  var portalHasContactModule = coreStore.getState().app.modules.some(function (x) {
    return x.id === 'contact';
  });
  useEffect(function () {
    if (contactSignersSetup) {
      saveSigners();
      setContactSignersSetup(false);
    }
  }, [contactSignersSetup]);
  useEffect(function () {
    setArrangedRecipients(recipients.some(function (r) {
      return r.data.order && r.data.order !== 0;
    }));
  }, []);
  useEffect(function () {
    var items = Array.from(recipients);
    if (arrangedRecipients) {
      items = items.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          data: _objectSpread(_objectSpread({}, i.data), {}, {
            required: false
          })
        });
      });
    }
    var recipientsHaveOrder = recipients.some(function (r) {
      return r.data.order && r.data.order !== 0;
    });
    if (!arrangedByUser && recipientsHaveOrder) {
      items.sort(function (a, b) {
        return a.data.order - b.data.order;
      });
    } else if (arrangedRecipients && !recipientsHaveOrder) {
      items = items.map(function (i, index) {
        return _objectSpread(_objectSpread({}, i), {}, {
          isDirty: true,
          data: _objectSpread(_objectSpread({}, i.data), {}, {
            order: index
          })
        });
      });
    } else {
      items = items.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          isDirty: true,
          data: _objectSpread(_objectSpread({}, i.data), {}, {
            order: 0
          })
        });
      });
    }
    setArrangedByUser(false);
    dispatch({
      type: 'UPDATE_RECIPIENTS',
      recipients: items
    });
  }, [arrangedRecipients]);
  var stack = useSelector(function (state) {
    return state.create.data.advanced.stack;
  });

  // For new recipients created, add default signerRoles for existing files
  useEffect(function () {
    // this is called too often
    var orderHasFiles = orderData.documents.length || orderData.attachments.length;
    var signersWithoutRoles = recipients.filter(function (x) {
      return orderHasFiles && x.data.signerRoles && !Object.keys(x.data.signerRoles).length || !x.data.signerRoles;
    });
    if (signersWithoutRoles.length) {
      var commitDispatch = function commitDispatch(signerId, fileId, fileCategory) {
        return dispatch({
          type: 'SET_SIGNER_ROLES',
          payload: {
            signerId: signerId,
            fileId: fileId,
            fileCategory: fileCategory
          }
        });
      };
      signersWithoutRoles.forEach(function (signer) {
        orderData.documents.forEach(function (doc) {
          commitDispatch(signer.id, doc.id, 'document');
        });
        orderData.attachments.forEach(function (attach) {
          commitDispatch(signer.id, attach.id, 'attachment');
        });
      });
    }
  }, [recipients]);

  // TODO: Move this to an action
  var handleAddSignerClick = function handleAddSignerClick() {
    dispatch({
      type: 'ADD_RECIPIENT',
      isOrdered: arrangedRecipients
    });
  };
  var handleAddMySelfClick = function handleAddMySelfClick() {
    dispatch(ordersActions.addSessionUserAsRecipient(arrangedRecipients));
  };
  useImperativeHandle(ref, function () {
    return {
      handleNextClick: function handleNextClick() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var dirtySigners, errorFound;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                dirtySigners = recipients.filter(function (signer) {
                  return signer.isDirty === true;
                });
                if (!(dirtySigners !== null && dirtySigners !== void 0 && dirtySigners.length)) {
                  _context.next = 15;
                  break;
                }
                _context.prev = 2;
                _context.next = 5;
                return saveSigners();
              case 5:
                errorFound = _context.sent;
                return _context.abrupt("return", !errorFound);
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                return _context.abrupt("return", false);
              case 13:
                _context.next = 16;
                break;
              case 15:
                return _context.abrupt("return", true);
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[2, 9]]);
        }))();
      }
    };
  });
  var saveSigners = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var dirtySigners, signersToSave, errorFound;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dirtySigners = recipients.filter(function (signer) {
              return signer.isDirty === true;
            });
            signersToSave = [];
            errorFound = false;
            dirtySigners.forEach(function (dirtySigner) {
              var _dirtySigner$data, _dirtySigner$data$sig, _sms_otp$, _dirtySigner$data2;
              var sms_otp = dirtySigner === null || dirtySigner === void 0 ? void 0 : dirtySigner.data.signatureMethods.filter(function (signatureMethods) {
                return (signatureMethods === null || signatureMethods === void 0 ? void 0 : signatureMethods.idp) === 'sms_otp';
              });
              if (recipients.some(function (recipient) {
                return recipient.id !== dirtySigner.id && recipient.data.firstName === dirtySigner.data.firstName && recipient.data.lastName === dirtySigner.data.lastName && recipient.data.mobileNumber === dirtySigner.data.mobileNumber && recipient.data.email === dirtySigner.data.email;
              })) {
                dispatch({
                  type: 'RECIPIENT_SAVE_FAILURE',
                  id: dirtySigner.id,
                  error: {
                    statusCode: 409,
                    message: [t('recipient_validation_duplicate_signer')]
                  }
                });
                errorFound = true;
              } else if (stack === 'green' && !((_dirtySigner$data = dirtySigner.data) !== null && _dirtySigner$data !== void 0 && (_dirtySigner$data$sig = _dirtySigner$data.signatureMethods) !== null && _dirtySigner$data$sig !== void 0 && _dirtySigner$data$sig.length)) {
                dispatch({
                  type: 'RECIPIENT_SAVE_FAILURE',
                  id: dirtySigner.id,
                  error: {
                    statusCode: 422,
                    message: [t('recipient_validation_no_signing_method')]
                  }
                });
                errorFound = true;
              } else if (((_sms_otp$ = sms_otp[0]) === null || _sms_otp$ === void 0 ? void 0 : _sms_otp$.idp) === 'sms_otp' && !((_dirtySigner$data2 = dirtySigner.data) !== null && _dirtySigner$data2 !== void 0 && _dirtySigner$data2.mobileNumber)) {
                dispatch({
                  type: 'RECIPIENT_SAVE_FAILURE',
                  id: dirtySigner.id,
                  error: {
                    message: [t('recipient_validation_sms_otp_require_mobilenumber')]
                  }
                });
                errorFound = true;
              } else {
                signersToSave.push(dirtySigner);
              }
            });
            if (!(signersToSave !== null && signersToSave !== void 0 && signersToSave.length)) {
              _context2.next = 7;
              break;
            }
            _context2.next = 7;
            return Promise.all(signersToSave.map(function (signer) {
              return dispatch(ordersActions.saveSigner('create', signer.id));
            }));
          case 7:
            return _context2.abrupt("return", errorFound);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveSigners() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleOnDragEnd = function handleOnDragEnd(result) {
    if (!result.destination || !arrangedRecipients) return;
    var items = Array.from(recipients);
    var _items$splice = items.splice(result.source.index, 1),
      _items$splice2 = _slicedToArray(_items$splice, 1),
      reorderedItem = _items$splice2[0];
    items.splice(result.destination.index, 0, reorderedItem);
    items = items.map(function (i, index) {
      return _objectSpread(_objectSpread({}, i), {}, {
        isDirty: true,
        data: _objectSpread(_objectSpread({}, i.data), {}, {
          order: index
        })
      });
    });
    dispatch({
      type: 'UPDATE_RECIPIENTS',
      recipients: items
    });
  };
  var handleOrderRecipients = function handleOrderRecipients(e, value) {
    setArrangedByUser(true);
    setArrangedRecipients(value);
  };
  var handleContactSearch = debounce( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e, value) {
      var _contacts$data, _lists$data, contacts, lists, listData, contactsData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!value) {
              _context3.next = 14;
              break;
            }
            _context3.next = 3;
            return contactService.getContacts({
              wildcard: value,
              limit: 100
            });
          case 3:
            contacts = _context3.sent;
            _context3.next = 6;
            return contactService.getContactLists(value);
          case 6:
            lists = _context3.sent;
            if (!(!(contacts !== null && contacts !== void 0 && (_contacts$data = contacts.data) !== null && _contacts$data !== void 0 && _contacts$data.length) && !((_lists$data = lists.data) !== null && _lists$data !== void 0 && _lists$data.length))) {
              _context3.next = 9;
              break;
            }
            return _context3.abrupt("return");
          case 9:
            setFoundLists(lists.data || []);
            setContactsOptions([]);
            listData = lists.data.map(function (l) {
              return {
                value: l.id,
                text: "".concat(l.name, " (").concat(t('contact_list_label_list'), ")")
              };
            });
            contactsData = contacts.data.map(function (c) {
              return {
                value: c.id,
                text: "".concat(c.firstName, " ").concat(c.lastName)
              };
            });
            setContactsOptions([].concat(_toConsumableArray(listData), _toConsumableArray(contactsData)));
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), 400);
  var addRecipientFromContact = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(id) {
      var contact, signerToAdd;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return contactService.getContact(id);
          case 2:
            contact = _context4.sent;
            signerToAdd = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
              firstName: contact.firstName,
              lastName: contact.lastName,
              email: contact.email,
              emailNotification: !!contact.email,
              companyName: contact.companyName,
              companyRole: contact.jobTitle,
              mobileNumber: contact.mobileNumber ? contact.mobileNumber.prefix + contact.mobileNumber.number : null
            }, "companyName", contact.companyName), "companyRole", contact.jobTitle), "language", defaultLanguage), "signatureMethods", signature.defaultSignatureMethods.map(function (sm) {
              var _sm$split = sm.split('.'),
                _sm$split2 = _slicedToArray(_sm$split, 2),
                signMechanism = _sm$split2[0],
                idp = _sm$split2[1];
              return {
                signMechanism: signMechanism,
                idp: idp
              };
            })), "isContact", true);
            _context4.next = 6;
            return dispatch({
              type: 'ADD_RECIPIENT',
              recipient: signerToAdd,
              isOrdered: arrangedRecipients
            });
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function addRecipientFromContact(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleContactSelect = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e, value) {
      var list;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setSelectedContacts([]);
            list = foundLists.find(function (l) {
              return l.id == value;
            });
            if (!list) {
              _context5.next = 7;
              break;
            }
            _context5.next = 5;
            return Promise.all(list.contacts.map(function (id) {
              return addRecipientFromContact(id);
            }));
          case 5:
            _context5.next = 9;
            break;
          case 7:
            _context5.next = 9;
            return addRecipientFromContact(value);
          case 9:
            setContactSignersSetup(true);
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleContactSelect(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    }
  }, recipients.length === 0 ? /*#__PURE__*/React.createElement(Empty, {
    emoji: "\uD83D\uDC40",
    heading: t('signorder_create_recipients_list_empty_heading'),
    message: t('signorder_create_recipients_list_empty_message'),
    action: t('button_text_add_recipient'),
    handleActionClick: handleAddSignerClick
  }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(HiddenFeature, {
    featureId: "signature_custom_smsnotification",
    onFeatureToggle: smsNotificationFeatureToggle
  }), /*#__PURE__*/React.createElement(Row, {
    marginBottom: "24px"
  }, /*#__PURE__*/React.createElement(_StyledColumn, {
    direction: media.matches.mobile.and('down') ? 'column' : 'row',
    justifyContent: media.matches.mobile.and('down') ? 'flex-start' : 'space-between'
  }, /*#__PURE__*/React.createElement(_StyledColumn2, {
    direction: "row",
    justifyContent: "flex-start",
    $_css: media.matches.mobile.and('down') ? '16px' : '0'
  }, /*#__PURE__*/React.createElement(SequentialToggle, null, /*#__PURE__*/React.createElement(Toggle, {
    label: t('signer_sequential_signing'),
    onChange: handleOrderRecipients,
    checked: arrangedRecipients
  }))), portalHasContactModule && /*#__PURE__*/React.createElement(_StyledAutocomplete, {
    options: contactsOptions,
    value: selectedContacts,
    onChange: handleContactSelect,
    onInputChange: handleContactSearch,
    label: t('search_in_contactbook'),
    $_css2: media.matches.mobile.and('down') ? '8px' : '8px 8px 8px 0'
  }), /*#__PURE__*/React.createElement(_StyledColumn3, {
    direction: media.matches.mobile.and('down') ? 'column' : 'row',
    justifyContent: media.matches.mobile.and('down') ? 'flex-start' : 'flex-end',
    alignItems: media.matches.mobile.and('down') ? 'flex-start' : 'flex-end'
  }, /*#__PURE__*/React.createElement(_StyledButton, {
    id: "add-myself-signer",
    secondary: true,
    onClick: handleAddMySelfClick,
    size: "sm",
    $_css3: media.matches.mobile.and('down') ? '4px 0' : '8px 8px 8px 0'
  }, t('signer_add_myself')), /*#__PURE__*/React.createElement(_StyledButton2, {
    id: "add-recipient-signer",
    secondary: true,
    onClick: handleAddSignerClick,
    size: "sm",
    $_css4: media.matches.mobile.and('down') ? '4px 0' : '8px 0 8px 8px'
  }, t('signer_add_new'))))), /*#__PURE__*/React.createElement(DragDropContext, {
    onDragEnd: handleOnDragEnd
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(Droppable, {
    droppableId: "recipients",
    flexGrow: "1"
  }, function (provided) {
    return /*#__PURE__*/React.createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), recipients.map(function (recipient, index) {
      return /*#__PURE__*/React.createElement(Draggable, {
        key: recipient.id,
        draggableId: recipient.id,
        index: index,
        isDragDisabled: !arrangedRecipients
      }, function (provided) {
        return /*#__PURE__*/React.createElement("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/React.createElement(Signer, {
          key: recipient.id,
          index: index,
          recipient: recipient,
          isDraggable: arrangedRecipients
        }));
      });
    }), provided.placeholder);
  })))));
});
export default Signers;
var _StyledColumn = styled(Column).withConfig({
  displayName: "Signers___StyledColumn",
  componentId: "sc-vqf31t-2"
})(["flex-wrap:wrap;align-items:center"]);
var _StyledColumn2 = styled(Column).withConfig({
  displayName: "Signers___StyledColumn2",
  componentId: "sc-vqf31t-3"
})(["margin-bottom:", ";"], function (p) {
  return p.$_css;
});
var _StyledAutocomplete = styled(Autocomplete).withConfig({
  displayName: "Signers___StyledAutocomplete",
  componentId: "sc-vqf31t-4"
})(["margin:", ";min-width:250px;"], function (p) {
  return p.$_css2;
});
var _StyledColumn3 = styled(Column).withConfig({
  displayName: "Signers___StyledColumn3",
  componentId: "sc-vqf31t-5"
})(["flex-wrap:wrap;align-items:center;"]);
var _StyledButton = styled(Button).withConfig({
  displayName: "Signers___StyledButton",
  componentId: "sc-vqf31t-6"
})(["margin:", ";"], function (p) {
  return p.$_css3;
});
var _StyledButton2 = styled(Button).withConfig({
  displayName: "Signers___StyledButton2",
  componentId: "sc-vqf31t-7"
})(["margin:", ";"], function (p) {
  return p.$_css4;
});